import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { BUSINESS, LOGO_URL, NAV_LINKS } from "../lib/data";
import { FilipinoSun } from "./Reveal";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-12 bg-foreground text-background overflow-hidden"
    >
      <div className="absolute -top-20 -right-20 w-72 h-72 text-secondary/15 pointer-events-none">
        <FilipinoSun size={288} />
      </div>
      <div className="absolute -bottom-32 -left-20 w-80 h-80 text-accent/15 pointer-events-none">
        <FilipinoSun size={320} />
      </div>

      <div className="container-eds py-16 lg:py-24 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Logo" className="w-14 h-14 object-contain" />
              <div>
                <div className="font-display text-2xl font-semibold">Ateng K Sarap</div>
                <div className="font-script text-lg text-accent -mt-1">Pinoy Fusion Catering</div>
              </div>
            </div>
            <p className="mt-7 text-background/80 max-w-md leading-relaxed text-base">
              {BUSINESS.hero}
            </p>
            <div className="mt-7 flex items-center gap-3">
              <a href="#" data-testid="footer-instagram" aria-label="Instagram"
                 className="w-11 h-11 rounded-full inline-flex items-center justify-center border border-background/30 hover:bg-accent hover:text-accent-foreground hover:border-accent transition-all">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" data-testid="footer-facebook" aria-label="Facebook"
                 className="w-11 h-11 rounded-full inline-flex items-center justify-center border border-background/30 hover:bg-accent hover:text-accent-foreground hover:border-accent transition-all">
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="font-script text-2xl text-accent mb-5">Explore</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-background/85 hover:text-accent transition-colors text-[15px]"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="font-script text-2xl text-accent mb-5">Visit & Reserve</div>
            <ul className="space-y-4 text-[15px]">
              <li className="flex gap-3">
                <MapPin className="w-5 h-5 text-secondary shrink-0 mt-0.5" />
                <span className="text-background/85">{BUSINESS.address}</span>
              </li>
              <li className="flex gap-3">
                <Phone className="w-5 h-5 text-secondary shrink-0 mt-0.5" />
                <a href={BUSINESS.phoneLink} data-testid="footer-phone-link"
                   className="text-background/85 hover:text-accent">{BUSINESS.phone}</a>
              </li>
              <li className="flex gap-3">
                <Mail className="w-5 h-5 text-secondary shrink-0 mt-0.5" />
                <a href={BUSINESS.emailLink} data-testid="footer-email-link"
                   className="text-background/85 hover:text-accent break-all">{BUSINESS.email}</a>
              </li>
            </ul>
            <p className="mt-6 text-sm text-background/60 italic font-script text-lg">
              Orders must be placed one week prior to your event.
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-background/15 relative">
        <div className="container-eds py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-background/60">
          <div>© {new Date().getFullYear()} Ateng K Sarap. All rights reserved.</div>
          <div className="flex items-center gap-2">
            <span>San Diego, California</span>
            <span className="text-accent">★</span>
            <span>Authentic Filipino Catering</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
